// extracted by mini-css-extract-plugin
export default {"item":"WebHostingSizeError-item_AqG2_"};